import { getField, updateField } from 'vuex-map-fields'

export const state = () => ({
  lastCallPermissionRequestStatus: null,
  callAttemptsRemaining: 0,
  isCallLimitReached: false,
  isCallPermissionRequestLimitReached: false,
  isBalanceAvailable: true,
  callWidget: {
    isShow: false,
    user: {
      avatar: '',
      fullname: '',
      phone: '',
      roomId: '',
    },
    session: '',
    event: '',
    status: '',
    id: '',
  },
})

export const getters = {
  getField,
}

export const mutations = {
  updateField,
  UPDATE_CALL_WIDGET(state, payload) {
    state.callWidget = {
      ...state.callWidget,
      ...payload,
    }
  },
  UPDATE_LAST_CALL_PERMISSION_STATUS(state, payload) {
    state.lastCallPermissionRequestStatus = payload
  },
  UPDATE_CALL_ATTEMPTS_REMAINING(state, payload) {
    state.callAttemptsRemaining = payload
  },
  UPDATE_CALL_LIMIT(state, payload) {
    state.isCallLimitReached = payload
  },
  UPDATE_CALL_PERMISSION(state, payload) {
    state.isCallPermissionRequestLimitReached = payload
  },
  UPDATE_CALL_BALANCE(state, payload) {
    state.isBalanceAvailable = payload
  },
}
